import { useTranslate } from '@ur-solutions/react-hooks'
import { AbsenceReportPerUserCard } from '../components/AbsenceSettings/absence-report-user-card'
import { ExportSection } from '../components/ExportsSettings/components'

export function ExportAbsences() {
  const translations = useTranslate({
    absences: 'common.absences',
  })

  return (
    <ExportSection header={translations.absences}>
      <AbsenceReportPerUserCard />
    </ExportSection>
  )
}
